/*
  LIOR - "Images with text carousel" in the style of iOS 27 (assets/lior-ios-carousel.css)

  On phones the cards sit in a native scroll-snap row (the browser does the
  physics: momentum, rubber band, snap). This file only adds:
    - a page control under the row that follows the scroll and can be tapped
    - Apple's light tile for a white card, so it stands off the white page
    - a one-time entrance when the row first scrolls into view
    - in the theme editor, selecting a block brings its card into view
  Tablet and desktop keep the theme's pinned reveal untouched.
*/
(function () {
  'use strict';

  if (window.__liorIosCarousel) return;
  window.__liorIosCarousel = true;

  var D = document;
  var W = window;
  var mqPhone = W.matchMedia('(max-width: 767px)');
  var mqReduce = W.matchMedia('(prefers-reduced-motion: reduce)');
  var mounted = [];

  function isRtl(el) { return W.getComputedStyle(el).direction === 'rtl'; }

  /* "rgb(255, 255, 255)" -> true for white or almost white */
  function isWhite(c) {
    var m = String(c).match(/rgba?\(([^)]+)\)/);
    if (!m) return false;
    var p = m[1].split(/[ ,/]+/).filter(Boolean).map(parseFloat);
    if (p.length > 3 && p[3] < 0.5) return false;
    return p[0] > 246 && p[1] > 246 && p[2] > 246;
  }

  /* once a card is tinted its own colour is no longer white, so only ever add */
  function tint(it) {
    if (!it.classList.contains('litc-white') && isWhite(W.getComputedStyle(it).backgroundColor)) it.classList.add('litc-white');
  }

  function mount(root) {
    var wrap = root.querySelector('.images-with-text-carousel--wrapper');
    var items = wrap ? Array.prototype.slice.call(wrap.querySelectorAll('.images-with-text-carousel--item')) : [];
    if (!wrap || !items.length) return null;
    var offs = [];
    function on(el, type, fn, opt) {
      el.addEventListener(type, fn, opt);
      offs.push(function () { el.removeEventListener(type, fn, opt); });
    }

    items.forEach(function (it, i) {
      it.style.setProperty('--litc-i', String(i));
      tint(it);
    });

    /* ---------------------------------------------------------- page control */
    var dots = null;
    var cur = -1;
    function paint(i) {
      if (!dots || i === cur) return;
      cur = i;
      Array.prototype.forEach.call(dots.children, function (b, k) {
        if (k === i) b.setAttribute('aria-current', 'true');
        else b.removeAttribute('aria-current');
      });
    }
    /* the card that shows the most of itself is the current one */
    function current() {
      var wr = wrap.getBoundingClientRect();
      var best = 0;
      var bestW = -1;
      for (var i = 0; i < items.length; i++) {
        var r = items[i].getBoundingClientRect();
        var w = Math.min(r.right, wr.right) - Math.max(r.left, wr.left);
        if (w > bestW + 1) { bestW = w; best = i; }
      }
      return best;
    }
    function go(i, smooth) {
      var it = items[i];
      if (!it) return;
      var wr = wrap.getBoundingClientRect();
      var ir = it.getBoundingClientRect();
      var cs = W.getComputedStyle(wrap);
      var pad = parseFloat(cs.scrollPaddingInlineStart || cs.scrollPaddingRight || cs.scrollPaddingLeft) || 0;
      var dx = isRtl(wrap) ? ir.right - (wr.right - pad) : ir.left - (wr.left + pad);
      wrap.scrollBy({ left: dx, behavior: smooth && !mqReduce.matches ? 'smooth' : 'auto' });
    }
    function buildDots() {
      if (dots || items.length < 2) return;
      dots = D.createElement('div');
      dots.className = 'litc-dots';
      items.forEach(function (it, i) {
        var b = D.createElement('button');
        b.type = 'button';
        b.className = 'litc-dot';
        b.setAttribute('aria-label', 'כרטיס ' + (i + 1) + ' מתוך ' + items.length);
        b.addEventListener('click', function () { go(i, true); });
        dots.appendChild(b);
      });
      var main = root.querySelector('.images-with-text-carousel--main') || wrap;
      main.insertAdjacentElement('afterend', dots);
      offs.push(function () { if (dots) dots.remove(); dots = null; });
      cur = -1;
      paint(current());
    }
    var raf = 0;
    on(wrap, 'scroll', function () {
      if (raf || !dots) return;
      raf = W.requestAnimationFrame(function () {
        raf = 0;
        paint(current());
      });
    }, { passive: true });
    offs.push(function () { if (raf) W.cancelAnimationFrame(raf); });
    function onMedia() {
      if (mqPhone.matches) buildDots();
      else if (dots) { dots.remove(); dots = null; }
    }
    onMedia();
    if (mqPhone.addEventListener) {
      mqPhone.addEventListener('change', onMedia);
      offs.push(function () { mqPhone.removeEventListener('change', onMedia); });
    }

    /* ---------------------------------------------------------- entrance */
    var design = W.Shopify && W.Shopify.designMode;
    if (mqPhone.matches && !mqReduce.matches && !design && 'IntersectionObserver' in W &&
        root.getBoundingClientRect().top > W.innerHeight) {
      root.classList.add('litc-pre');
      var io = new IntersectionObserver(function (entries) {
        if (!entries[entries.length - 1].isIntersecting) return;
        io.disconnect();
        root.classList.add('litc-in');
        W.requestAnimationFrame(function () { root.classList.remove('litc-pre'); });
        setTimeout(function () { root.classList.remove('litc-in'); }, 1600);
      }, { threshold: 0.12 });
      io.observe(root);
      offs.push(function () { io.disconnect(); root.classList.remove('litc-pre', 'litc-in'); });
    }

    /* ---------------------------------------------------------- the editor */
    on(D, 'shopify:block:select', function (e) {
      if (!mqPhone.matches) return;
      var k = items.indexOf(e.target && e.target.closest ? e.target.closest('.images-with-text-carousel--item') : null);
      if (k !== -1) go(k, false);
    });

    return {
      root: root,
      destroy: function () { offs.forEach(function (f) { f(); }); }
    };
  }

  function boot() {
    mounted = mounted.filter(function (m) {
      if (m.root.isConnected) return true;
      m.destroy();
      return false;
    });
    Array.prototype.forEach.call(D.querySelectorAll('.litc[data-litc]'), function (root) {
      for (var i = 0; i < mounted.length; i++) if (mounted[i].root === root) return;
      var m = mount(root);
      if (m) mounted.push(m);
    });
  }

  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  W.addEventListener('load', function () {
    /* colours settle once every stylesheet is in */
    mounted.forEach(function (m) {
      Array.prototype.forEach.call(m.root.querySelectorAll('.images-with-text-carousel--item'), tint);
    });
  });
  D.addEventListener('shopify:section:load', boot);
  D.addEventListener('shopify:section:unload', function (e) {
    mounted = mounted.filter(function (m) {
      if (e.target && e.target.contains(m.root)) {
        m.destroy();
        return false;
      }
      return true;
    });
  });
})();
